import { workloadScenarioSettingsLoaded } from 'owa-scenario-settings';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';

export const workloadScenarioSettingsLoadedMutator = mutator(
    workloadScenarioSettingsLoaded,
    actionMessage => {
        const { settings } = actionMessage;
        if (settings.timePanelCalendarIds && settings.timePanelCalendarIds.length > 0) {
            getStore().calendarIds = settings.timePanelCalendarIds;
        }
    }
);
